'use client';

export const createHash = (value: unknown) => {
  if (value === null || value === undefined) return null;

  const hash = JSON.stringify(value);
  return hash;
};
